import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { StatusOfClaimService } from 'services/statusOfClaim';
import { statusOfClaim as StatusOfClaimView } from 'ui/views/widgets/statusOfClaim';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { StatusOfClaim } from 'ui/containers/StatusOfClaim';
 *
 * // render
 * <StatusOfClaim propName='propValue'/>
 */
export class StatusOfClaim extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind submit function
        this.onFormSubmit = this.onFormSubmit.bind( this );

        // start new service instance
        this.statusOfClaimService = new StatusOfClaimService();
    }

    /**
     * Action executed when user submits form
     */
    async onFormSubmit ( formData ) {
        log.debug( 'StatusOfClaim.onFormSubmit()' );

        // get context and success action url
        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        // get status of form submission
        const { status } = await this.statusOfClaimService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open(); // show error overlay
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <StatusOfClaimView
                { ...this.props }
                onFormSubmit={ this.onFormSubmit }
            />
        );
    }
}

// set display name
StatusOfClaim.displayName = 'StatusOfClaim';

// set default props
StatusOfClaim.defaultProps = {};

// prop types
StatusOfClaim.propTypes = {};
